import { FormGenericContent } from '../../content.types';

const baseSubmit = {
  displayText: 'Continue',
  color: 'primary' as const,
};

export const profileForm: FormGenericContent = {
  internalName: 'profile',
  header: 'Tell us about yourself',
  subheader: 'We use this to personalize your care.',
  fieldsCollection: { items: [] },
  button: baseSubmit,
};

export const addAddressForm: FormGenericContent = {
  internalName: 'add-address',
  header: 'Add your address',
  subheader: 'We use your address to confirm care availability.',
  fieldsCollection: { items: [] },
  button: baseSubmit,
};

export const addChildForm: FormGenericContent = {
  internalName: 'add-child',
  header: 'Add your child',
  subheader: 'Tell us a little about your child so we can provide care.',
  fieldsCollection: { items: [] },
  button: { displayText: 'Add child', color: 'primary' },
};

export const editChildForm: FormGenericContent = {
  internalName: 'edit-child',
  header: 'Edit your child',
  fieldsCollection: { items: [] },
  button: { displayText: 'Save', color: 'primary' },
};

export const editInviteForm: FormGenericContent = {
  internalName: 'edit-invite',
  header: 'Edit invitation',
  fieldsCollection: { items: [] },
  button: { displayText: 'Save', color: 'primary' },
};

export const inviteCaregiverForm: FormGenericContent = {
  internalName: 'invite-caregiver',
  header: 'Invite a caregiver',
  subheader: 'Add another caregiver to help manage your child’s care.',
  fieldsCollection: { items: [] },
  button: { displayText: 'Send invite', color: 'primary' },
};

export const accountProfileForm: FormGenericContent = {
  internalName: 'account-profile',
  header: 'Your profile',
  fieldsCollection: { items: [] },
  button: { displayText: 'Save', color: 'primary' },
};

export const agreementForm: FormGenericContent = {
  internalName: 'agreement',
  header: 'Review and accept',
  fieldsCollection: { items: [] },
  button: { displayText: 'I agree', color: 'primary' },
};

export const pcpForm: FormGenericContent = {
  internalName: 'pcp',
  header: 'Add your pediatrician',
  subheader: 'Tell us about your current pediatrician (optional).',
  fieldsCollection: { items: [] },
  button: baseSubmit,
};

export const planPaymentForm: FormGenericContent = {
  internalName: 'plan-payment',
  header: 'Add payment method',
  fieldsCollection: { items: [] },
  button: { displayText: 'Pay & continue', color: 'primary' },
};

export const carePlanForm: FormGenericContent = {
  internalName: 'care-plan',
  header: 'Care plan',
  fieldsCollection: { items: [] },
};

export const homeForm: FormGenericContent = {
  internalName: 'home',
  header: 'Welcome home',
  fieldsCollection: { items: [] },
};

export const patientAttestationForm: FormGenericContent = {
  internalName: 'patient-attestation',
  header: 'Confirm care for %PATIENT_NAMES%',
  body: '%ACCOUNT_HOLDER_NAME% added you as a caregiver for %PATIENT_NAMES%. Confirm to accept access.',
  fieldsCollection: { items: [] },
  button: { displayText: 'Accept all', color: 'primary' },
  secondaryButton: { displayText: 'Decline all', color: 'secondary' },
};

export const insuranceAgreementForm: FormGenericContent = {
  internalName: 'insurance-agreement',
  header: 'Insurance agreement',
  fieldsCollection: { items: [] },
  button: { displayText: 'Continue', color: 'primary' },
};

export const planSelectionPaygForm: FormGenericContent = {
  internalName: 'plan-selection-payg',
  header: 'Choose your plan',
  fieldsCollection: { items: [] },
};

export const planSelectionForm: FormGenericContent = {
  internalName: 'plan-selection',
  header: 'Choose your plan',
  fieldsCollection: { items: [] },
};

export interface PlanPaymentCardContentLite {
  overline?: string;
  header: string;
  body: string;
  legal: string;
  button: {
    displayText: string;
    url?: string;
    color?: 'primary' | 'secondary';
  };
}

export const planPaymentCardContent: PlanPaymentCardContentLite = {
  overline: 'Plan',
  header: 'Confirm your plan',
  body: 'Add a payment method to start your Summer Health membership.',
  legal:
    'Your subscription renews automatically. You can cancel anytime from your account.',
  button: { displayText: 'Confirm and pay', color: 'primary' },
};

export const forms: Record<string, FormGenericContent> = {
  T0TDo1mBsxCZ6xWFKCM73: profileForm,
  '7aXDkciF6jXDe7ze8Pfjbv': addAddressForm,
  '1HkzmFBDkWTKaXkfr3KhRA': addChildForm,
  '4KLLg1dOSWSuGFrkETpqoz': addChildForm,
  '4aMahVqIXWdlwccQx2lfyR': editChildForm,
  '3kUrS58VierJdy9Stcx5w7': editInviteForm,
  '1FyVNovElLiqnBC9nCcw0U': inviteCaregiverForm,
  '1pe3B9IRc7zeYZoHTr8VmV': accountProfileForm,
  '7jj6Ik1GgKTRBuI94WCGnN': agreementForm,
  XUmLmxIfIf4Xov3ZBYRn7: pcpForm,
  '6J3hlAfXMYzYpWbTttCOWz': planPaymentForm,
  N4Z25PgSnQYieBFIH15Yp: homeForm,
  '3acSh0bjBkxvXkPpWjo1Eu': patientAttestationForm,
  '6d0uWVLgpoFMXo2c3zE16Z': insuranceAgreementForm,
  '28SNPuNWQuFl6hkWuadDGC': planSelectionPaygForm,
  '2Ucnqrc9kX1pQ6RwPxpp17': planSelectionForm,
};
